import React from 'react'
import PropTypes from 'prop-types'

import { useSelector } from 'react-redux'

import { InfoTooltipIcon } from '../common'
import useSessionStatusModal from '../../hooks/useSessionStatusModal'
import { CloningStatusEnum } from '../../constants'
import { selectEditURLForSession } from '../../reducers/clone_leagues_sessions'

const SessionName = ({session}) => {
  const editSessionURL = useSelector(selectEditURLForSession(session.id))
  const { openModal } = useSessionStatusModal()

  const onClick = (event) => {
    event.stopPropagation()

    if (session.status === CloningStatusEnum.DRAFT) {
      window.location.href = editSessionURL
    } else {
      openModal(session.id)
    }
  }

  const leagueNames = Object.values(session?.data?.leagues ?? {}).map(league => league.name).filter(Boolean)
  const visibleNames = leagueNames.slice(0, 5)
  const remainingCount = leagueNames.length - visibleNames.length
  const tooltip = (
    <div>
      {visibleNames.map((name, i) => <div key={i}>{name}</div>)}
      {remainingCount > 0 && <div>+{remainingCount} more</div>}
    </div>
  )

  return (<span className={'cls-session-name-container'}>
    <span
      onClick={(event) => onClick(event)}
      className={'cls-session-name'}>
      {session.name}
    </span>
    {leagueNames.length > 0 && <InfoTooltipIcon tooltip={tooltip}/>}
  </span>)

}

SessionName.propTypes = {
  session: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    status: PropTypes.oneOf(Object.values(CloningStatusEnum)).isRequired,
    data: PropTypes.shape({
      leagues: PropTypes.objectOf(PropTypes.shape({
        name: PropTypes.string,
      })),
    }),
  }),
}

export default SessionName
